var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-4014.862 -17709.646 32.693 31.363",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_32390_cc",
    transform: "translate(-4029 -17723.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(14.138 13.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    className: "cls-31",
    d: "M40.341,44.79H20.628c-2.626,0-4.733-1.017-5.782-2.79s-.927-4.109.336-6.41L25.336,17.08c1.291-2.355,3.119-3.653,5.148-3.653s3.858,1.3,5.15,3.653L45.787,35.592c1.262,2.3,1.385,4.635.336,6.409S42.967,44.79,40.341,44.79ZM30.484,16.565c-.818,0-1.691.737-2.4,2.022L17.933,37.1a3.446,3.446,0,0,0-.388,3.3,3.448,3.448,0,0,0,3.083,1.25H40.341a3.448,3.448,0,0,0,3.083-1.25,3.443,3.443,0,0,0-.388-3.3L32.881,18.587C32.177,17.3,31.3,16.565,30.484,16.565Z",
    transform: "translate(-14.138 -13.427)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-2",
    transform: "translate(28.607 23.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    className: "cls-32",
    d: "M43.582,46.886a1.878,1.878,0,1,1,3.755,0,1.878,1.878,0,1,1-3.755,0Zm.693-2.958-.483-9.5h3.335l-.461,9.5Z",
    transform: "translate(-43.582 -34.426)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.a8d9f426.svg";
export { ForwardRef as ReactComponent };